export const savePasswordChangeQuery = `
mutation saveOffer($id :JSON,$oldPassword:String ,$newPassword:String){
    UserdataChangePassword(id:$id ,oldPassword:$oldPassword ,newPassword:$newPassword)  
  }
`;


  
  